import { render, staticRenderFns } from "./modalAdicionarItens.vue?vue&type=template&id=7eb0533d&scoped=true&"
import script from "./modalAdicionarItens.vue?vue&type=script&lang=js&"
export * from "./modalAdicionarItens.vue?vue&type=script&lang=js&"
import style0 from "./modalAdicionarItens.vue?vue&type=style&index=0&id=7eb0533d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb0533d",
  null
  
)

export default component.exports